import React, { useState, useEffect } from 'react';
import { usePublicVendors } from '../services/usePublicVendors';

function PreviewCarousel() {
  const [images, setImages] = useState([]);
  const { vendors } = usePublicVendors();

  useEffect(() => {
    const allImages = [];
    vendors.forEach(v => {
      (v.itemPreviews || []).forEach(item => {
        if (item.images && item.images.length > 0) {
          allImages.push({ url: item.images[0].url, name: item.name });
        }
          });
        });
        // Shuffle
        for (let i = allImages.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [allImages[i], allImages[j]] = [allImages[j], allImages[i]];
        }
        setImages(allImages.slice(0, 12));
  }, [vendors]);

  if (images.length === 0) return null;

  return (
    <div className="preview-carousel">
      <div className="preview-track">
        {images.concat(images).map((img, idx) => (
          <div className="preview-item" key={idx}>
            <img src={img.url} alt={img.name} />
          </div>
        ))}
      </div>
    </div>
  );
}

export default PreviewCarousel;
